import {ContentHeader} from '@components';
import React, {useState, useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import {Button} from 'react-bootstrap';
const $ = require('jquery');
import {toast} from 'react-toastify';
import TableItem from './report/TableItem';
import * as AuthService from '../../services/auth';
import ModalItem from './modal/ModalItem';
import ModalRecost from './modal/ModalRecost';
import ModalTicket from './modal/ModalTicket';
import {logoutUser} from '@store/reducers/auth';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
// import { useStateWithCallbackLazy } from 'use-state-with-callback';

export default function Approve() {
  const planid_ref = useRef();
  const system_ref = useRef();
  const user = useSelector((state: any) => state.auth.currentUser);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [select, setSelect] = useState(true);
  const [selectCb, setSelectCb] = useState([
    {value: 'A', label: 'แสดงทั้งหมด (all)', select: true},
    {value: '1', label: 'เบิกค่าเดินทาง (cdsexp)', select: false}
  ]);
  const [showMd, setShowMd] = useState(false);
  const [showMd2, setShowMd2] = useState(false);
  const [showMd3, setShowMd3] = useState(false);
  const [pageHistory, setPageHistory] = useState(0);
  //   const [data, setData] = useStateWithCallbackLazy<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [item, setItem] = useState<any>(null);
  const [item2, setItem2] = useState<any>(null);
  const [mode, setMode] = useState<any>('read');
  const [dropdowns, setDropdowns] = useState<any>({});
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    downloadWaitMe(null);
    downloadDropdownWs(user.ID_EMP, true);
  }, []);

  const downloadDropdownWs = async (staffid: string, updateCb: boolean) => {
    try {
      //ผิด ต้องเป็นใบงาน
      const dropdowns = await AuthService.downloadDropdownCar(
        `${staffid}?type=A`
      );
      console.log('DDL');
      console.log(dropdowns);
      if (dropdowns.error) throw 'timeout';

      if (Object.keys(dropdowns).length !== 0) {
        console.log(dropdowns);
        setDropdowns(dropdowns);

        if (updateCb) setSelectCb(dropdowns.TYPE.DATA);
      }
    } catch (error) {
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };

  const onAgree = async (planid: any, system: any) => {
    await updatePlanApproveWs({
      planid: planid,
      status: 'approve',
      system: system
    });
    await onRefresh(planid);
    hideModal();
  };
  const onReject = async (planid: any, system: any) => {
    planid_ref.current = planid;
    system_ref.current = system;
    setShowMd3(!showMd3);
    // await updatePlanApproveWs({
    //   planid: planid,
    //   status: 'reject'
    // });
    // await onRefresh(planid);
    // hideModal();
  };

  const confirmModal = async () => {
    await updatePlanApproveWs({
      planid: planid_ref.current,
      status: 'reject',
      system: system_ref.current
    });
    await onRefresh(planid_ref.current);
    setShowMd3(false);
  };

  const updatePlanApproveWs = async (input: any) => {
    try {
      const result = await AuthService.updatePlanApprove(input);
      if (result.result === 'SUCCESS') toast.success('ปรับปรุงข้อมูลแล้ว');
      else toast.error('ปรับปรุงข้อมูลผิดพลาด');
    } catch (error) {}
  };
  const hideModal = () => {
    $('#exampleModal').modal('hide');
  };

  const toggleModal = async (item: any) => {
    // ใส่ data ที่นี้
    // item.planid

    await downloadDropdownWs(item.staffid, false);

    // $('#exampleModal').modal('toggle');
    setShowMd(!showMd);
    console.log(item);
    setItem(item);
  };

  const togglePrintModal = (item: any) => {
    // $('#printModal').modal('toggle');
    setShowMd2(!showMd2);
    setItem2(item);
  };

  const onRefresh = async (planid: any) => {
    await downloadWaitMe(planid);

    if (planid.system === 'recost') {
      setShowMd(false);
    }

    console.log('MOO-RELOAD TABLE FIN');
  };

  const downloadWaitMe = async (planid: any) => {
    try {
      console.log('MOO-RELOAD TABLE START');
      setLoading(true);
      const data = await AuthService.downloadWaitMe('approver');
      console.log(data);
      if (data.error) throw 'timeout';
      setData(
        data.map((e: any) => ({
          ...e,
          distanceValue: (e.distance / 1000).toFixed(2),
          distanceActualValue: (e.distanceActual / 1000).toFixed(2)
        }))
      );
      if (planid !== null) {
        console.log(data.filter((e: any) => e.planid === planid)[0]);
        setItem(data.filter((e: any) => e.planid === planid)[0]);
      }
      setLoading(false);
    } catch (error: any) {
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };

  const setPageHandle = (page: number) => {
    setPage(page);
  };

  const setPageHistoryHandle = (page: number) => {
    setPageHistory(page);
  };

  const countWaitMe = (res_apv: any) => {
    let run: any[] = [];
    let isReject = false;
    res_apv.map((e: any) => {
      e.path.map((el: any) => {
        if (el.status === '') {
          run.push(el.by);
        }

        if (el.status === 'reject') {
          isReject = true;
        }
      });
    });

    if (isReject) {
      return false;
    } else {
      if (run.length === 0) {
        return false;
      } else {
        if (run[0].includes(user.ID_EMP)) return true;
        else return false;
      }
    }
    return true;
  };

  return (
    <div>
      <Modal
        show={showMd}
        className={'modal-fullscreen'}
        onHide={() => setShowMd(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>รายละเอียด</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {item && item.system === 'travel' ? (
            <ModalItem
              id={item ? item.planid : 0}
              key={`k-${item ? item.planid : 0}`}
              onRefresh={onRefresh}
              onHide={hideModal}
              item={item}
              mode={mode}
              dropdowns={dropdowns}
            ></ModalItem>
          ) : item && item.system === 'recost' ? (
            <ModalRecost
              id={item ? item.planid : 0}
              key={`r-${item ? item.planid : 0}`}
              onRefresh={onRefresh}
              onHide={hideModal}
              item={item}
              mode={mode}
              dropdowns={dropdowns}
            ></ModalRecost>
          ) : (
            <></>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={showMd2}
        className={'modal-fullscreen'}
        onHide={() => setShowMd2(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>พิมพ์ใบงาน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalTicket
            id={item2 ? item2.planid : 0}
            key={`k-${item2 ? item2.planid : 0}`}
            onRefresh={onRefresh}
            onHide={hideModal}
            item={item2}
            mode={mode}
            dropdowns={dropdowns}
          ></ModalTicket>
        </Modal.Body>
      </Modal>

      <Modal show={showMd3} onHide={() => setShowMd3(false)}>
        <Modal.Header closeButton>
          <Modal.Title>ยืนยัน</Modal.Title>
        </Modal.Header>
        <Modal.Body>ท่านยืนยันการไม่อนุมัติหรือไม่?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowMd3(false)}>
            ปิด
          </Button>
          <Button variant="primary" onClick={() => confirmModal()}>
            ยืนยัน
          </Button>
        </Modal.Footer>
      </Modal>

      <ContentHeader title="Approval" />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              {/* <Card className="card-primary">
                <Card.Header>รายการรออนุมัติทั้งหมด</Card.Header>
                <Card.Body> */}
              <TableItem
                loading={loading}
                select={select}
                setSelect={setSelect}
                selectCb={selectCb}
                setSelectCb={setSelectCb}
                me={user.ID_EMP}
                onAgree={onAgree}
                onReject={onReject}
                onToggle={toggleModal}
                onPrintToggle={togglePrintModal}
                // items={data}
                items1={
                  data.length === 0
                    ? []
                    : data.filter((e) => countWaitMe(e.res_apv))
                }
                items2={
                  data.length === 0
                    ? []
                    : data.filter((e) => !countWaitMe(e.res_apv))
                }
                onPageChange={setPageHandle}
                page={page}
                onPageHistoryChange={setPageHistoryHandle}
                pageHistory={pageHistory}
              />
              {/* </Card.Body>
              </Card> */}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
